// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39VWd","icon":"styles_icon__3pWI3"};